import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-amber-950 text-amber-100" data-id="element-104" data-mp="3gfsmscqd8umz">
      <div className="h-1.5 w-full bg-amber-500" aria-hidden="true" data-id="element-105" data-mp="3ggk90wy2pg0l" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-106" data-mp="32ovvcp86ejhi">
        <p className="text-lg font-extrabold uppercase text-stone-50" data-id="element-107" data-mp="36p6d0z5byyc7">{productShortName}</p>
        <p className="mt-3 text-sm" data-id="element-108" data-mp="3uf0mr7ucs6s8">Created by drilling and well engineering education specialists, for educators worldwide.</p>
        <p className="mt-6 border-t border-amber-100/20 pt-6 text-xs" data-id="element-109" data-mp="38zbozae1d6l">
          © 2026 {productShortName} — All rights reserved.
        </p>
      </div>
    </footer>;
}